import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import VideoParallax from './components/VideoParallax';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <div className="app">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <VideoParallax />
      <Testimonials />
      <Contact />
      <Footer />

      {/* Floating WhatsApp */}
      <a
        href="https://wa.me/38349343079"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="WhatsApp"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.214l-.293-.175-3.041.798.813-2.97-.192-.304A8 8 0 1112 20z"/>
        </svg>
      </a>
    </div>
  );
}

function Preloader() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: '#0a0a0a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      <div style={{
        width: '50px',
        height: '50px',
        marginBottom: '24px',
        color: '#c9a84c',
      }}>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 4L26 12L34 14L28 22L29 30L20 27L11 30L12 22L6 14L14 12L20 4Z"
                stroke="currentColor" strokeWidth="1.5" fill="none">
            <animate attributeName="stroke-dasharray" from="0 200" to="200 0" dur="1.5s" fill="freeze" />
          </path>
          <circle cx="20" cy="18" r="4" stroke="currentColor" strokeWidth="1">
            <animate attributeName="r" from="0" to="4" dur="0.8s" begin="0.8s" fill="freeze" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.8s" fill="freeze" />
          </circle>
        </svg>
      </div>
      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '1.6rem',
        fontWeight: 300,
        color: '#f5f0eb',
        letterSpacing: '4px',
        animation: 'fadeIn 1s ease forwards',
      }}>
        Paradise Events
      </div>
      <div style={{
        width: '120px',
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #c9a84c, transparent)',
        marginTop: '16px',
        animation: 'expandLine 1.5s ease forwards',
      }} />
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes expandLine {
          from { width: 0; opacity: 0; }
          to { width: 120px; opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default App;
